import React, { FC, useMemo } from "react";
import Category, { CategoryTypes } from "@components/common/Category";
import { useSearch } from "@helpers/context/SearchContext";
import { getAbsoluteUrl } from "@helpers/getAbsoluteUrl";
import { searchURL } from "@helpers/searchURL";
import { t } from "@helpers/translate";
import Link from "next/link";
import { twMerge } from "tailwind-merge";

const MenuItem = ({ category }: { category: CategoryTypes }) => {
  const { filters, tabsWithContent } = useSearch();

  const isAvailable = useMemo(() => {
    if (
      tabsWithContent.includes(CategoryTypes.guides) &&
      category === CategoryTypes.guides
    ) {
      return true;
    } else if (
      tabsWithContent.includes(CategoryTypes.tours) &&
      category === CategoryTypes.tours
    ) {
      return true;
    } else if (
      tabsWithContent.includes(CategoryTypes.transportation) &&
      category === CategoryTypes.transportation
    ) {
      return true;
    } else if (
      tabsWithContent.includes(CategoryTypes["online-tours"]) &&
      category === CategoryTypes["online-tours"]
    ) {
      return true;
    } else {
      return false;
    }
  }, [tabsWithContent]);

  if (isAvailable) {
    return (
      <Link
        href={getAbsoluteUrl(
          searchURL({
            ...(filters.country && { country: filters.country }),
            ...(filters.city && { city: filters.city }),
            t: category,
            q: filters.q,
          })
        )}
        passHref
        title={t({
          id: "common.link.title",
          message: "GoWithGuide - Private Tours & Local Tour Guides",
        })}
      >
        <Category
          category={category}
          selected={filters.t === category}
          actived={true}
        />
      </Link>
    );
  }

  return <Category category={category} actived={false} />;
};

const Menu: FC<Props> = ({ className = "" }) => {
  return (
    <div className={twMerge(`grid grid-cols-4 gap-2`, className)}>
      <MenuItem category={CategoryTypes.guides} />
      <MenuItem category={CategoryTypes.tours} />
      <MenuItem category={CategoryTypes.transportation} />
      <MenuItem category={CategoryTypes["online-tours"]} />
    </div>
  );
};

interface Props {
  className?: string;
}

export const SearchTabs: FC<Props> = ({ className = "", ...props }) => {
  return (
    <div className={className}>
      <Menu {...props} />
    </div>
  );
};
